import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'tipodenovedades',
    loadChildren: () => import('./modules/tipodenovedades/tipodenovedades.module').then(m => m.TipodenovedadesModule)
  },
  {
    path: 'novedadescomerciales',
    loadChildren: () => import('./modules/novedadescomerciales/novedadescomerciales.module').then(m => m.NovedadescomercialesModule)
  },
  {
    path: 'bonificacionesextras',
    loadChildren: () => import('./modules/bonificacionesextras/bonificacionesextras.module').then(m => m.BonificacionesextrasModule)
  },
  {
    path: 'citafutura',
    loadChildren: () => import('./modules/citafutura/citafutura.module').then(m => m.CitafuturaModule)
  },
  {
    path: 'conceptocomisiones',
    loadChildren: () => import('./modules/conceptocomisiones/conceptocomisiones.module').then(m => m.ConceptocomisionesModule)
  },
  {
    path: 'metavendedor',
    loadChildren: () => import('./modules/metavendedor/metavendedor.module').then(m => m.MetavendedorModule)
  },
  {
    path: 'agrupacionnovedades',
    loadChildren: () => import('./modules/agrupacionnovedades/agrupacionnovedades.module').then(m => m.AgrupacionnovedadesModule)
  },
  {
    path: 'periodosmetas',
    loadChildren: () => import('./modules/periodosmetas/periodosmetas.module').then(m => m.PeriodosmetasModule)
  },
  {
    path: 'ajustedevalores',
    loadChildren: () => import('./modules/ajustedevalores/ajustedevalores.module').then(m => m.AjustedevaloresModule)
  },
  {
    path: 'sincronizacionsap',
    loadChildren: () => import('./modules/sincronizacionsap/sincronizacionsap.module').then(m => m.SincronizacionSapModule)
  },
  {
    path: 'garantizados',
    loadChildren: () => import('./modules/garantizados/garantizados.module').then(m => m.GarantizadosModule)
  },
  
  {
    path: 'porcentajecumplimientobono',
    loadChildren: () => import('./modules/porcentajecumplimientobono/porcentajecumplimientobono.module').then(m => m.PorcentajeCumplimientoBonoModule)
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'prefix' },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'prefix' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComisionesdevendedoresRoutingModule { }
